import React from "react";

import * as sc from "./Avatar.styled";

export const PLACEHOLDER_URL = "/images/placeholder.png";

const Avatar = ({ name, picture }) => {
  return (
    <sc.Avatar>
      {picture ? (
        <img
          src={picture}
          alt={`Avatar ${name}`}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = PLACEHOLDER_URL;
          }}
        />
      ) : (
        <img src={PLACEHOLDER_URL} alt={`Placeholder image ${name ?? ""}`} />
      )}
    </sc.Avatar>
  );
};

export default Avatar;
